import { NgModule } from "@angular/core";
import { SecurityPanelItemComponent } from "./security-panel-item.component";
import { CommonModule } from "@angular/common";
import { SharedModule } from "src/app/shared/shared.module";

@NgModule({
  imports: [CommonModule, SharedModule],
  exports: [SecurityPanelItemComponent],
  declarations: [SecurityPanelItemComponent],
})
export class SecurityPanelItemModule {}
